export default "__VITE_ASSET__lIS9frqL__"